const reportDB       = require ('../../../../../components/report/report-db')
const report         = require ('../../../../../components/report/report')
const style          = require ('../../../../../components/report/report-style')
const css            = style.get()
const timeDate       = require ('../../../../../js-handler/time-date')


export function start(detail){  
         
    const phpFile          = 'server/php/sql/report.php' 
    const fullcontPurchase = document.getElementById('purchase-fullcont')
    let dataDbid           = '';

    if(detail.source == 'fullcont'){
      
      dataDbid         = fullcontPurchase.getAttribute('data-dbid')
      detail.inf       = {entity: 'purchase', report:'purchase-report-one', id: dataDbid }

      reportDB.select(detail, phpFile, (data)=>{

        insert(detail, data)

      })
    }else if(detail.source == 'dt'){
    
      dataDbid = detail.dbid
      detail.inf    = {entity: 'purchase', report:'purchase-report-one', id: dataDbid }

      reportDB.select(detail, phpFile, (data)=>{ 

        insert(detail, data)

      })

    }else{
      console.log('Errorrrrrrrrrrrrr')
    }

}/**/

function insert(detail, data){
    
    report.show(detail, ()=>{

        const pageTarget = document.getElementById('report-page-right')
        const body       = generate(data[0])

        pageTarget.insertAdjacentHTML("beforeend", body )  

    })

}/*insert*/

function generate(data){ 

    var body                = ''
    const pruchaseItem      = JSON.parse(data.pruchaseItem)
    const soldItem          = JSON.parse(data.soldItem)
    const LostItem          = JSON.parse(data.lostItems)
    const ReturnItem        = JSON.parse(data.returnedItems)
    const returnedSoldItem = JSON.parse(data.returnedSoldItems)


    body += generateHeader(data)
    body += generateTop(data)
    body += generatePurchaseTable(data,pruchaseItem)
    body += generateSoldTable(soldItem)
    body += generatePurchaseTableReturnSoldItem(returnedSoldItem)
    body += generatePurchaseTableLostReturn(data,LostItem,ReturnItem)


    body += `</div> <!-- dataCont -->`
    body += `<div class="report-page">`

    return body
}

function generateHeader(data){

  var header = ''
      header +=`<div class="report-page" id="miDiv5" ${css.table}>`
      header +=`
              <div class="report-appbar report-appbar-black" >

                      <div  data-detail='{"click": [ 
                                                  {"dest":"ripple" }, 
                                                  {"dest":"report", "act":"remove" } ] }' >
                          <svg><use xlink:href="../css/svg.svg#close"></use></svg>
                      </div>

                      <h1>Report</h1>

                  <div class="fr" data-detail='{"click": [ 
                                              {"dest":"ripple" }, 
                                              {"dest":"report", "act":"print" }  ] }' >
                          <svg><use xlink:href="../css/svg.svg#print"></use></svg>
                          <label>Print</label>
                  </div>
              </div> <!-- appbar -->
      `
      header +=`
              <div class="dataCont">
                  <h1  ${css.f32}>${data.code} Status Report</h1>
                  <p   ${css.f14} >The Top Shows a Summary Of The Cost, Income and Profit. The Rest Shows The Records Of Purchased And Sold Items Qty/Pricing</p>
      `
    return header

}

function generateTop(data) {

  var table = ` <table ${css.table} > `
     table += `
                <tr>
                  <th ${css.thNoline}    >Code</th>
                  <th ${css.thNoline}    >#REF</th>
                  <th ${css.thNoline}    >Vendor</th>
                  <th ${css.thNoline}    >P.O. Total</th>
                  <th ${css.thNoline}  >Sold Amount</th>
                </tr> 

                <tr>
                  
                  <td ${css.td0}  ><b>${data.code}   </b></td>
                  <td ${css.td0}  ><b>${data.reference_number}   </b></td>
                  <td ${css.td0}  ><b>${data.vendor} </b></td>
                  <td ${css.td0}  ><b>${data.totalPurchasedAmount} </b></td>
                  <td ${css.td0}  ><b>${data.totalSoldAmount} </b></td>
                </tr> 

                <tr>
                  <th ${css.thNoline}  >Purchased Qty</th>
                  <th ${css.thNoline}  >Sold Qty</th>
                  
                  <th ${css.thNoline}  >COGS</th>
                  <th ${css.thNoline}  >Profit</th>
                </tr> 

                <tr>
                  <td ${css.td0}  ><b>${data.totalPurchaseQty} </b></td>
                  <td ${css.td0}  ><b>${data.totalSoldQty} </b></td>
                 
                  <td ${css.td0}  ><b>${data.totalCogs} </b></td>
                  <td ${css.td0}  ><b>${data.profit} </b></td>
                </tr> 
            `
  table += `</table>`

  return table

}/**/




function generatePurchaseTable(data,pruchaseItem){

        var purchasedTotal = 0;
        var percent        = 0;
        var unitTotalCost  = 0;
        var avg_sold_price = 0;
        var profit         = 0;
        var if_lost_return = false;
        var table = ``;
        var table_detail = ``;

        if (parseFloat(data.totalLostQty) > 0 || parseFloat(data.totalReturnedQty) > 0) {
          if_lost_return = true;
        }

        for ( let i=0; i< pruchaseItem.length; i++ ){
            unitTotalCost         = pruchaseItem[i].unitTotalCost.replace("$","")
            avg_sold_price        = pruchaseItem[i].avg_sold_price.replace("$","")
            profit                = avg_sold_price > 0 ? (parseFloat(avg_sold_price) - parseFloat(unitTotalCost)) * pruchaseItem[i].sold_qty : '0.00';
            var soldQtyCostAmount = pruchaseItem[i].sold_qty * parseFloat(unitTotalCost);
            var soldAmount        = pruchaseItem[i].sold_amount;
            var ganancia          = soldAmount - soldQtyCostAmount;
            percent               = soldQtyCostAmount > 0 ? (100 * (ganancia / soldQtyCostAmount)).toFixed(2) : '0.00';

            profit = profit - (parseInt(pruchaseItem[i].lost_qty) *  parseFloat(unitTotalCost));

            table_detail += `
                <tr>
                  
                  <td ${css.td} >${pruchaseItem[i].name}</td>
                  <td ${css.td} >${pruchaseItem[i].type_selling}</td>
                  <td ${css.td} >${pruchaseItem[i].purchase_qty}</td>                  
                  <td ${css.td} >${pruchaseItem[i].sold_qty}</td>
                  <td ${css.td} >${pruchaseItem[i].avaialable}</td>
                  <td ${css.td} >${pruchaseItem[i].unitTotalCost}</td>
                  <td ${css.td} >${cashVal(Math.ceil(profit))} / ${percent}%</td>
                  <td ${css.td} >${pruchaseItem[i].avg_sold_price}</td>
                  <td ${css.td} >${pruchaseItem[i].rowTotal}</td>
            `
            if (if_lost_return) {
              table_detail += `<td ${css.td} >${pruchaseItem[i].lost_qty}</td>`
              table_detail += `<td ${css.td} >${pruchaseItem[i].returned_qty}</td>`
            }
            table_detail += `
                </tr>
            `;
            
            purchasedTotal += parseFloat(pruchaseItem[i].rowTotal.replace(/[$,]/g, ''));
        }

        var table = `  
          <h2 ${css.tableTitle}>Purchased Items</h2>
          <table ${css.table} >
            <tr >
            <th ${css.th}>NAME</th>
            <th ${css.th}>SIZE</th>
            <th ${css.th}>QTY</th>
            <th ${css.th}>SOLD QTY</th>
            <th ${css.th}>AVAIL</th>                  
            <th ${css.th}>UNIT COST + COGS</th>
            <th ${css.th}>PROFIT</th>
            <th ${css.th}>AVG SOLD PRICE</th>
            <th ${css.th}>ITEMS TOTAL</th>
            ${if_lost_return == true ? `<th ${css.th}>ITEMS LOST</th><th ${css.th}>ITEMS RETURNS</th>`: ""}
            </tr>
            ${table_detail}
            `;



        table += `<tr><td colspan='8' ${css.td}><div align='right'><h3>TOTAL</h3></div></td><td ${css.td} ><h3>${cashVal(purchasedTotal)}</h3></td></tr></table>`

        return table

}


function generateSoldTable(soldItem){ 

        var soldTotal = 0;
        var table     = `
              <h2 ${css.tableTitle}>Sold Items</h2>                        
              <table ${css.table} >
                <tr>
                  <th ${css.th}>GO TO SALE</th>
                  <th ${css.th}>SALE DATE</th>
                  <th ${css.th}>CUSTOMER</th>
                  <th ${css.th}>ITEM</th>
                  <th ${css.th}>QTY</th>
                  <th ${css.th}>SOLD PRICE</th>
                  <th ${css.th}>ROW TOTAL EARNINGS</th>
                  <th ${css.th}>ROW TOTAL</th>
                  
                </tr> 
        `
        for ( let i=0; i< soldItem.length; i++ ){ //console.log('for>>>', soldItem.length)
            
           let detailHtml = `data-detail='{"click": [ {"dest":"ripple" },  
                          {"dest":"report",  "act":"jump", 
                           "actJump":"goToSales", "dtId":"sale-dt", "toSearch":"${soldItem[i].saleCode}"  } ] }'` 
            
            table += `
                <tr>
                  <td class='tdClick' ${css.td} ${detailHtml} >${soldItem[i].saleCode}</td>
                  <td ${css.td}>${soldItem[i].saleDate}</td>
                  <td ${css.td}>${soldItem[i].customer}</td>
                  <td ${css.td}>${soldItem[i].name}</td>
                  <td ${css.td}>${soldItem[i].qty}</td>
                  <td ${css.td}>${soldItem[i].soldPrice}</td>
                  <td ${css.td}>${soldItem[i].rowTotalEarnings}</td>
                  <td ${css.td}>${soldItem[i].rowTotal}</td>
                  
                </tr> 
            `
            soldTotal += parseFloat(soldItem[i].rowTotal.replace(/[$,]/g, ''));
        }

        table += `<tr><td colspan='7' ${css.td}><div align='right'><h3>TOTAL</h3></div></td><td ${css.td} ><h3>${cashVal(soldTotal)}</h3></td></tr></table>`

        return table
}

// funcion para generar la tabla de los lost y return solo si hay datos de estos
function generatePurchaseTableLostReturn(data, LostItem, ReturnItem) {
  let table = '';
  if (parseFloat(data.totalReturnedQty) > 0) {
    table += `  
        <h2 ${css.tableTitle}>Returned Items</h2>
        <table ${css.table} >
          <tr >
            <th ${css.th}>ITEM</th>
            <th ${css.th}>RETURNED QTY</th>
            <th ${css.th}>AMOUNT</th>
            <th ${css.th}>RETURN DATE</th>
            <th ${css.th}>NOTES</th>                  
          </tr>
      `;

    let totalReturnedQty = 0;
    let totalAmount = 0;

    for (let i = 0; i < ReturnItem.length; i++) {
      if (parseInt(ReturnItem[i].id) > 0) {
        table += `
        <tr>
            <td ${css.td} >${ReturnItem[i].name}</td>
            <td ${css.td} >${ReturnItem[i].return_qty}</td>
            <td ${css.td} >${cashVal(ReturnItem[i].return_price)}</td>
            <td ${css.td} >${timeDate.getdateshort(ReturnItem[i].date)}</td>                  
            <td ${css.td} >${ReturnItem[i].notes}</td>
        </tr> 
        `;
        totalReturnedQty = totalReturnedQty + parseInt(ReturnItem[i].return_qty);
        totalAmount = totalAmount + parseFloat(ReturnItem[i].return_price);
      }
    }
    table += `<tr>
                <td ${css.td}>
                  <div align='right'>
                    <h3>TOTAL</h3>
                  </div>
                </td>
                <td ${css.td} >
                  <h3>${totalReturnedQty}</h3>
                </td>
                <td ${css.td} >
                  <h3>${cashVal(totalAmount)}</h3>
                </td>
              </tr>
            </table>`;
  }

  if (parseFloat(data.totalLostQty) > 0) {
    table += `  
        <h2 ${css.tableTitle}>Lost Items</h2>
        <table ${css.table} >
          <tr >
          <th ${css.th}>ITEM</th>
          <th ${css.th}>LOST QTY</th>
          <th ${css.th}>AMOUNT</th>
          <th ${css.th}>DATE</th>
          <th ${css.th}>NOTES</th>                  
          </tr>
      `;

    let totalLostQty = 0;
    let totalAmount = 0;
    console.log("aaaaaaaaaaaaaa")

    for (let i = 0; i < LostItem.length; i++) {
      if (parseInt(LostItem[i].id) > 0) {
        table += `
        <tr>
            <td ${css.td} >${LostItem[i].name}</td>
            <td ${css.td} >${LostItem[i].lost_qty}</td>
            <td ${css.td} >${cashVal(LostItem[i].lost_price)}</td>
            <td ${css.td} >${timeDate.getdateshort(LostItem[i].date)}</td>                  
            <td ${css.td} >${LostItem[i].notes}</td>
        </tr> 
        `;

        totalLostQty = totalLostQty + parseInt(LostItem[i].lost_qty);
        totalAmount = totalAmount + parseFloat(LostItem[i].lost_price);
      }

  


    }

    table += `<tr>
                <td ${css.td}>
                  <div align='right'>
                    <h3>TOTAL</h3>
                  </div>
                </td>
                <td ${css.td} >
                  <h3>${totalLostQty}</h3>
                </td>
                <td ${css.td} >
                  <h3>${cashVal(totalAmount)}</h3>
                </td>
              </tr>
            </table>`;
    table += `</table>`;


  }



  return table

}


// funcion para generar la tabla de los return  de los sales, solo si hay datos de estos
// y si una linea del sale se retorno completa
function generatePurchaseTableReturnSoldItem(returnedSoldItem) {
  let table = '';
  if (returnedSoldItem.length > 0) {
    table += `  
        <h2 ${css.tableTitle}>Returned Sold Items</h2>
        <table ${css.table} >
          <tr >
            <th ${css.th}>ITEM</th>
            <th ${css.th}>RETURNED QTY</th>
            <th ${css.th}>AMOUNT</th>
            <th ${css.th}>RETURN DATE</th>
            <th ${css.th}>NOTES</th>                  
          </tr>
      `;

    let totalReturnedQty = 0;
    let totalAmount = 0;

    for (let i = 0; i < returnedSoldItem.length; i++) {
        table += `
        <tr>
            <td ${css.td} >${returnedSoldItem[i].name}</td>
            <td ${css.td} >${returnedSoldItem[i].return_qty}</td>
            <td ${css.td} >${cashVal(returnedSoldItem[i].return_price)}</td>
            <td ${css.td} >${timeDate.getdateshort(returnedSoldItem[i].date)}</td>                  
            <td ${css.td} >${returnedSoldItem[i].notes}</td>
        </tr> 
        `;
        totalReturnedQty = totalReturnedQty + parseInt(returnedSoldItem[i].return_qty);
        totalAmount = totalAmount + parseFloat(returnedSoldItem[i].return_price);
    }
    table += `<tr>
                <td ${css.td}>
                  <div align='right'>
                    <h3>TOTAL</h3>
                  </div>
                </td>
                <td ${css.td} >
                  <h3>${totalReturnedQty}</h3>
                </td>
                <td ${css.td} >
                  <h3>${cashVal(totalAmount)}</h3>
                </td>
              </tr>
            </table>`;
  }


  return table

}


function cashVal(value) {
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

